import { Dialog, IconButton, TableRow } from '@mui/material';
import moment from 'moment';

import IMedicalCertificate from '../../../interfaces/IMedicalCertificate';
import { HeadTableCell } from '../../../components/custom-table-sort-label/CustomTableSortLabel.styled';
import FollowupStatus from '../../followup/FollowupStatus';
import { getTimeQuanitity } from '../../followup/followupUtil';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ViewMedicalCertificateDialog from './ViewMedicalCertificateDialog';
import { useState } from 'react';
import Transition from '../../followup/FollowupTransition';

interface IRowProps {
  medicalCertificateRow: IMedicalCertificate;
  smallScreen: boolean;
}

const ViewTable = (props: IRowProps, indx: number) => {
  const medicalCertificateRow = props.medicalCertificateRow;
  const [openDialog, setOpenDialog] = useState(false);
  const getDiseaseClassifitation = (medicalCertificate: IMedicalCertificate): string => {
    const diseaseClassification =
      medicalCertificate.diseaseClassifications && medicalCertificate.diseaseClassifications[0];
    if (diseaseClassification?.code) {
      return diseaseClassification?.code;
    }
    return ``;
  };

  return (
    <>
      {!props.smallScreen ? (
        <TableRow key={`${indx}`} hover={true}>
          <HeadTableCell>{medicalCertificateRow.protocolNumber || 'protocolo'}</HeadTableCell>
          <HeadTableCell>{moment(medicalCertificateRow?.createdAt).format('DD/MM/yyyy HH:mm')}</HeadTableCell>
          <HeadTableCell>{moment(medicalCertificateRow.documentDate).format('DD/MM/yyyy')}</HeadTableCell>
          <HeadTableCell>{getTimeQuanitity(medicalCertificateRow)}</HeadTableCell>
          <HeadTableCell>{getDiseaseClassifitation(medicalCertificateRow)}</HeadTableCell>
          <HeadTableCell>
            <FollowupStatus status={medicalCertificateRow.status} />
          </HeadTableCell>
          <HeadTableCell>{medicalCertificateRow?.typeDocument?.description || 'Descrição do Documento'}</HeadTableCell>
        </TableRow>
      ) : (
        <TableRow key={`${indx}`} hover={true}>
          <HeadTableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpenDialog(true)}>
              <RemoveRedEyeIcon />
            </IconButton>
          </HeadTableCell>

          <HeadTableCell>{medicalCertificateRow.protocolNumber || 'protocolo'}</HeadTableCell>
          <HeadTableCell>{moment(medicalCertificateRow?.createdAt).format('DD/MM/yyyy HH:mm')}</HeadTableCell>
        </TableRow>
      )}
      <Dialog open={openDialog} fullWidth TransitionComponent={Transition}>
        <ViewMedicalCertificateDialog
          isOpen={openDialog}
          closeDialog={() => setOpenDialog(false)}
          medicalCertificate={medicalCertificateRow}
        />
      </Dialog>
    </>
  );
};

export default ViewTable;
